import { withSnackbar } from 'notistack'
import React from 'react'

import { withApi } from '../../shared/api/ApiContext'
import { CustomSnackBarContent } from '../atom/FieldFactory/CustomSnackBar'

class SnackMessages extends React.Component {
  componentDidMount() {
    const { api: { connector } = {} } = this.props
    connector && (this.errorSubscription = connector.listenToAlerts(this.onAlert))
  }

  componentWillUnmount() {
    this.errorSubscription && this.errorSubscription.unsubscribe()
  }

  onAlert = (alert) => {
    const { enqueueSnackbar } = this.props
    const { message, stack, variant, autoHideDuration, isPersistent = false, anchorOrigin } = alert

    if (message === undefined) {
      return
    }
    // This function call is the one that is in charge of creating the snacks
    enqueueSnackbar('', {
      anchorOrigin: anchorOrigin || { vertical: 'bottom', horizontal: 'center' },
      autoHideDuration: autoHideDuration * 1000 || 6000,
      persist: isPersistent,
      children: (key) => (
        <CustomSnackBarContent
          onClose={() => this.handleClose2(key)}
          message={message + (stack ? ': ' + stack : '')}
          variant={variant}
        />
      ),
    })
  }

  handleClose2 = (key) => {
    const { closeSnackbar } = this.props
    closeSnackbar(key)
  }

  render() {
    return <div></div>
  }
}

export default withSnackbar(withApi(SnackMessages))
